export enum TypePersonUpdate {
    PERSON_UPDATE = 'update-person',
    PERSON_SAVE = 'save-person',
    PERSON_SAVE_IDENTIFICATION = 'save-identification',
    PERSON_UPDATE_IDENTIFICATION = 'update-identification',
}

export class TypePersonUtil {
    public static toString(typePersonUpdate: TypePersonUpdate) {
        return TypePersonUpdate[typePersonUpdate];
    }
}